const UiMeet3dPhotoType = {
  MAIN_USER_AVATAR: 0,
  MAIN_USER_BACK_BADGE: 1,
  GREETING_BOT_AVATAR: 2,
};

export default UiMeet3dPhotoType;
